package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.tedd.db.Objective_reflection
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

/** Réflexions numérotées d'un objectif dont l'échéance est passée. Aucune pénalité, jamais. */
class ObjectiveReflectionRepository(private val db: TeddDatabase) {

    fun observeByObjective(objectiveId: String): Flow<List<Objective_reflection>> =
        db.objectiveReflectionQueries.selectByObjective(objectiveId).asFlow().mapToList(Dispatchers.Default)

    /** Enregistre la réflexion de la tentative suivante et renvoie son numéro. */
    suspend fun record(objectiveId: String, text: String, missedDeadline: String?): Long = withContext(Dispatchers.Default) {
        val existing = db.objectiveReflectionQueries.selectByObjective(objectiveId).executeAsList()
        val attempt = (existing.maxOfOrNull { it.attempt } ?: 0L) + 1L
        val now = nowMillis()
        db.objectiveReflectionQueries.insert(newId("refl"), objectiveId, attempt, text, missedDeadline, now, now)
        attempt
    }

    suspend fun softDelete(id: String) = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.objectiveReflectionQueries.softDelete(now, now, id)
    }
}
